import { useDispatch, useSelector, useStore } from "react-redux"
import type { RootAppDispatch, RootAppState, RootAppStore } from "."

export const useAppDispatch = useDispatch.withTypes<RootAppDispatch>()
export const useAppSelector = useSelector.withTypes<RootAppState>()
export const useAppStore = useStore.withTypes<RootAppStore>()
